var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManuallyCreate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1206_10732)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2669 35.036H25.6578C24.5018 35.036 23.5647 35.9732 23.5647 37.1292V96.6768H61.629C61.629 103.07 67.0956 107.537 73.4988 107.504C79.7921 107.472 84.9403 102.137 84.9403 95.8448V51.6275H73.8302C72.058 51.6275 68.2669 47.7483 68.2669 45.977V35.036Z",
    fill: "#E4EBF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7127 96.4893H18.0563C18.0563 102.2 22.2103 106.329 27.6602 107.244L29.5789 107.404L73.3226 107.317C66.9595 107.317 61.5505 102.43 61.7127 96.4893Z",
    fill: "#253368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3339 40.6212H32.8033C32.3524 40.6212 31.9869 40.9867 31.9869 41.4375V50.9682C31.9869 51.4191 32.3524 51.7845 32.8033 51.7845H42.3339C42.7848 51.7845 43.1503 51.4191 43.1503 50.9682V41.4375C43.1503 40.9867 42.7848 40.6212 42.3339 40.6212Z",
    fill: "#597EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0139 57.279H32.7841C32.3333 57.279 31.9678 57.6445 31.9678 58.0953V59.2535C31.9678 59.7043 32.3333 60.0698 32.7841 60.0698H73.0139C73.4648 60.0698 73.8303 59.7043 73.8303 59.2535V58.0953C73.8303 57.6445 73.4648 57.279 73.0139 57.279Z",
    fill: "#597EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0139 65.682H32.7841C32.3333 65.682 31.9678 66.0475 31.9678 66.4983V67.6565C31.9678 68.1074 32.3333 68.4728 32.7841 68.4728H73.0139C73.4648 68.4728 73.8303 68.1074 73.8303 67.6565V66.4983C73.8303 66.0475 73.4648 65.682 73.0139 65.682Z",
    fill: "#597EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0139 74.085H32.7841C32.3333 74.085 31.9678 74.4505 31.9678 74.9013V76.0595C31.9678 76.5104 32.3333 76.8759 32.7841 76.8759H73.0139C73.4648 76.8759 73.8303 76.5104 73.8303 76.0595V74.9013C73.8303 74.4505 73.4648 74.085 73.0139 74.085Z",
    fill: "#597EF7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M68.2617 48.9579V51.1383C68.2617 51.6068 68.4567 52.0542 68.8001 52.3729C69.1435 52.6917 69.6042 52.853 70.0714 52.818L84.9971 51.7078L68.2617 48.9579Z",
    fill: "#CCD7EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9133 43.344L68.2434 34.9828L68.2661 51.0075C68.2661 51.3928 68.5785 51.7052 68.9638 51.7052H84.9971L76.9133 43.344Z",
    fill: "#FAAD14"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1206_10732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.7076 92.2429L101.631 97.8913",
    stroke: "#E4EBF7",
    strokeWidth: 1.88133,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.355 93.4095C95.3822 92.9496 95.842 91.7358 95.382 90.6986C94.922 89.6613 93.7164 89.1933 92.6891 89.6532C91.6619 90.1131 91.2021 91.3268 91.6622 92.3641C92.1222 93.4014 93.3278 93.8694 94.355 93.4095Z",
    fill: "#E4EBF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.115 88.17C117.143 87.7101 117.602 86.4963 117.142 85.4591C116.682 84.4218 115.477 83.9538 114.45 84.4137C113.422 84.8736 112.963 86.0873 113.423 87.1246C113.883 88.1619 115.088 88.6299 116.115 88.17Z",
    fill: "#E4EBF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.485 99.2039L106.402 82.4319",
    stroke: "#E4EBF7",
    strokeWidth: 1.88133,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.639 97.3292C104.666 96.8693 105.872 97.3373 106.332 98.3746C106.792 99.4118 106.332 100.626 105.305 101.085C104.278 101.545 103.072 101.077 102.612 100.04C102.152 99.0028 102.612 97.7891 103.639 97.3292Z",
    fill: "#E4EBF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.838 79.1416L113.021 84.461",
    stroke: "#E4EBF7",
    strokeWidth: 1.88133,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.739 79.8744C108.334 80.9288 107.155 81.4569 106.104 81.054C105.054 80.6511 104.53 79.4697 104.934 78.4154C105.338 77.3611 106.518 76.833 107.569 77.2359C108.619 77.6388 109.143 78.8201 108.739 79.8744Z",
    fill: "#E4EBF7"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9003 11.8937L15.3706 26.1232H18.1091L22.6388 11.8937H19.9003Z",
    fill: "#4E5C93"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4411 13.5114H10.5339H8.70134C8.55837 13.5114 8.4425 13.6273 8.4425 13.7703V15.6029V22.414V24.2466C8.4425 24.3896 8.55837 24.5054 8.70134 24.5054H10.5339H13.4411C13.584 24.5054 13.6999 24.3896 13.6999 24.2466V22.6728C13.6999 22.5299 13.584 22.414 13.4411 22.414H10.5339V15.6029H13.4411C13.584 15.6029 13.6999 15.487 13.6999 15.3441V13.7703C13.6999 13.6273 13.584 13.5114 13.4411 13.5114Z",
    fill: "#E4EBF7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3079 13.5114H27.4753H24.5682C24.4252 13.5114 24.3093 13.6273 24.3093 13.7703V15.3441C24.3093 15.487 24.4252 15.6029 24.5682 15.6029H27.4753V22.414H24.5682C24.4252 22.414 24.3093 22.5299 24.3093 22.6728V24.2466C24.3093 24.3896 24.4252 24.5054 24.5682 24.5054H27.4753H29.3079C29.4509 24.5054 29.5667 24.3896 29.5667 24.2466V22.6728V15.3441V13.7703C29.5667 13.6273 29.4509 13.5114 29.3079 13.5114Z",
    fill: "#E4EBF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1206_10732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1206_10732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2695,
    height: 34.1484,
    fill: "white",
    transform: "translate(82.4648 99.0833) rotate(-69.0186)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManuallyCreate);
export default __webpack_public_path__ + "static/media/manually-create.744f117ce9687e5377fd7eaa81310f8a.svg";
export { ForwardRef as ReactComponent };